// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Table Container */
.table-container {
  width: 100%;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/technical-letters/deleted-letter-logs/deleted-letter-logs.component.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* Table Container */\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
